<template>
  <v-container fluid class="holdings-management">
    <h1 class="text-h5 mb-4">Carteiras</h1>

    <holdings-filters :filters.sync="requestFilters" />

    <v-card>
      <v-card-text>
        <holdings-table
          fixed-header
          dense

          :items="results"
          :loading="isFetchingData"

          must-sort
          sort-by="refDate"
          sort-desc

          hide-default-footer
          :items-per-page="-1"
        />
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { debounce } from 'lodash';
import moment from 'moment-loyall';

import api from '@/services/api';
import store from '@/services/store';
import { loadValueFromUrl, saveValuesOnUrl } from '@/utils/router-utils';

import HoldingsTable from '../components/HoldingsTable.vue';
import HoldingsFilters from '../components/HoldingsFilters.vue';

function parseRequestFilters(rawFilters) {
  const ALLOWED_STATUS = [
    'CALCULATED',
    'APPROVED',
    'APPROVED_WITH_WARNINGS',
  ];

  const houseFundIds = rawFilters.houseFundIds ?? [];

  const initialDate = rawFilters.initialDate ?? '1970-01-01';
  const finalDate = rawFilters.finalDate ?? '2999-01-01';

  return {
    status: ALLOWED_STATUS.join(','),
    houseFunds: houseFundIds.length > 0 ? houseFundIds.join(',') : null,
    refDate: `${initialDate}:${finalDate}`,
  };
}

export default {
  name: 'HoldingsManagement',

  components: {
    HoldingsTable,
    HoldingsFilters,
  },

  data: () => ({
    requestFilters: {
      houseFundIds: loadValueFromUrl('houseFundIds')?.split(',') ?? [],
      initialDate: loadValueFromUrl('initialDate') ?? moment().businessSubtract(5, 'days', 'brasil').format('YYYY-MM-DD'),
      finalDate: loadValueFromUrl('finalDate') ?? null,
    },

    results: [],
    isFetchingData: false,
  }),

  watch: {
    requestFilters: {
      deep: true,
      immediate: true,
      handler(newFilters) {
        const houseFundIds = newFilters.houseFundIds.join(',');
        saveValuesOnUrl({ ...newFilters, houseFundIds });

        this.fetchData();
      },
    },
  },

  created() {
    this.fetchData();
  },

  methods: {
    fetchData: debounce(async function debouncedFetchData() {
      this.isFetchingData = true;

      try {
        const filters = parseRequestFilters(this.requestFilters);

        const { data } = await api.holdings.getHoldingsList(filters);

        this.results = data.results ?? [];
      } catch (error) {
        if (error.response?.status === 401 || error.response?.status === 403) {
          return;
        }

        store.dispatch('alert/showAlert', { errorList: [error.message] });
      } finally {
        this.isFetchingData = false;
      }
    }, 200),
  },
};
</script>
